<div class="d-flex padding-top-l padding-bottom-l">
  <ion-button
    fill="clear"
    size="small"
    class="border-light-2"
    expand="full"
    color="dark"
    (click)="onDecrement()"
    id="decrement-button"
    aria-label="decrease grade times achieved"
    >
    <ion-icon slot="icon-only" name="remove-sharp" id="decrement-icon"></ion-icon>
  </ion-button>
  <!-- Use text + inputmode so native number steppers are not shown; +/- buttons control increments. -->
  <ion-input
    type="text"
    inputmode="numeric"
    class="border-light-2"
    [(ngModel)]="grade.timesAchieved"
    (ionBlur)="valueChanged()"
    max="99"
    min="0"
    id="no-of-times-achieved-input"
    mode="md"
    aria-label="number of times achieved input"
  ></ion-input>
  <ion-button expand="full" size="small" (click)="onIncrement()" id="increment-button" aria-label="increase grade times achieved">
    <ion-icon slot="icon-only" name="add-sharp" id="increment-icon"></ion-icon>
  </ion-button>
</div>
@if (!valid && !grade.timesAchievedRangeValid()) {
  <div class="color-error margin-top-xs margin-bottom-l d-flex" id="s">
    <span class="d-flex align-center padding-right-xs font-l">
      <ion-icon aria-hidden="true" name="alert-circle-sharp" id="error-icon"></ion-icon>
    </span>
    <span aria-label="Please enter a number between 0 to 99." id="error-message">Please enter a number between 0-99.</span>
  </div>
}
